import clsx from 'clsx';
import React, { ReactNode } from 'react';
import { v4 as uuid } from 'uuid';

import Header from '../Header';

interface SectionItem {
  key?: string;
}

interface SectionHeaderProps {
  title?: string;
  leftSection?: ReactNode | (ReactNode & SectionItem)[];
  rightSection?: ReactNode | (ReactNode & SectionItem)[];
  className?: string;
}

export function SectionHeader({
  title,
  leftSection,
  rightSection,
  className,
}: SectionHeaderProps): JSX.Element {
  return (
    <div
      className={clsx('flex justify-between items-center pt-3 pr-1', className)}
    >
      <div className="flex items-center gap-4">
        {title && <Header>{title}</Header>}
        {Array.isArray(leftSection)
          ? leftSection.map((item: ReactNode & SectionItem) => (
              <React.Fragment key={item?.key || uuid()}>{item}</React.Fragment>
            ))
          : leftSection}
      </div>
      <div className="flex items-center gap-4">
        {Array.isArray(rightSection)
          ? rightSection.map((item: ReactNode & SectionItem) => (
              <React.Fragment key={item?.key || uuid()}>{item}</React.Fragment>
            ))
          : rightSection}
      </div>
    </div>
  );
}
